import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { api, errMsg, mediaUrl } from "@/lib/api";
import { uploadFile } from "@/lib/upload";
import { MediaCard } from "./MediaCard";

export default function MediaManager() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = useCallback(() => api.get("/admin/media").then((r) => setFiles(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);

  const upload = async (list) => {
    if (!list.length) return;
    setLoading(true);
    const results = await Promise.allSettled(list.map(uploadFile));
    results.forEach((r, i) => { if (r.status === "rejected") toast.error(`${list[i].name} : ${errMsg(r.reason)}`); });
    setLoading(false);
    toast.success("Téléversement terminé");
    load();
  };

  const copy = (url) => { navigator.clipboard.writeText(mediaUrl(url)); toast.success("Lien copié"); };
  const del = async (id) => {
    try { await api.delete(`/admin/media/${id}`); toast.success("Fichier retiré"); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="media-manager">
      <div className="flex items-start justify-between gap-4 mb-6">
        <div><h1 className="font-heading text-3xl font-black">Médiathèque</h1><p className="text-zinc-500 text-sm mt-1">Photos, audios et PDF téléversés. Copiez un lien pour l'utiliser dans un article.</p></div>
        <label className={`inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2.5 text-xs font-bold uppercase tracking-wider cursor-pointer hover:bg-red-700 ${loading ? "opacity-60" : ""}`}>
          <Upload size={14} /> {loading ? "Téléversement…" : "Téléverser"}
          <input data-testid="media-upload-input" type="file" multiple accept="image/*,audio/*,application/pdf" className="hidden" disabled={loading} onChange={(e) => upload([...e.target.files])} />
        </label>
      </div>
      {!files.length && <p className="text-sm text-zinc-500 bg-white border p-6 text-center">Aucun fichier.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {files.map((f, i) => <MediaCard key={f.id} file={f} index={i} onCopy={copy} onDelete={del} />)}
      </div>
    </div>
  );
}
